import { createModel, createSaga, createReducer } from '@/store/tools';
import { put, takeEvery } from 'redux-saga/effects';
import http from '@/assets/api/http';

/**
 * 当saga写法需要自定义实现时，请使用依赖注入，把第二个参数变成具体的saga创建实现函数
 */
const getCardcentreEnum = (T) => createSaga(T('getCardcentreEnum'), (type) => {
    return function* () {
        yield takeEvery(type, function* requestData(action) {
            try {
                let result = yield http('/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', { enumName: action.payload.enumName }, 'POST');
                switch (action.payload.type) {
                    case 'CouponUseTypeEnum'://推广渠道
                        yield put({ type: T('CouponUseTypeEnum'), payload: result });
                        break;
                    case 'centreState'://发放状态
                        yield put({ type: T('centreState'), payload: result });
                        break;
                    case 'type'://卡券类型
                        yield put({ type: T('type'), payload: result });
                        break;
                    case 'status'://启用状态
                        yield put({ type: T('status'), payload: result });
                        break;
                    case 'termValidity'://有效期
                        yield put({ type: T('termValidity'), payload: result });
                        break;
                }
            } catch (e) {
                yield put({ type: 'SAGA_ERROR', payload: { error: e } });
            }
        });
    };
});

/**
 * 当reducer写法需要自定义实现时，请使用依赖注入，把第一个参数变成具体的reducer创建实现函数
 */
const cardEnum = (T) => createReducer((autostate) => {
    return (state = autostate, action) => {
        switch (action.type) {
            case T('CouponUseTypeEnum'):
                return { ...state, CouponUseTypeEnum: action.payload.result };
            case T('centreState'):
                return { ...state, centreState: action.payload.result };
            case T('type'):
                return { ...state, centreType: action.payload.result };
            case T('status'):
                return { ...state, centreStatus: action.payload.result };
            case T('termValidity'):
                return { ...state, termValidityList: action.payload.result };
            default:
                return state;
        }
    };
}, { CouponUseTypeEnum: [], centreState: [], centreType: [], centreStatus: [], termValidityList: [] });
const dataList = { dataList: [], pageNum: 1, pageSize: 20, resultTotal: 0 };
const model = {
    namespace: 'cardcentre',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getCardcentreList': T('getCardcentreList'),
            'getCardcentreEnum': T('getCardcentreEnum'),
            'getCardcentreListDetail': T('getCardcentreListDetail'),
            'getCardcentreListState': T('getCardcentreListState'),
            'getCardcentreDetail': T('getCardcentreDetail'),
        },
        actions: {
            'getCardcentreList': A('getCardcentreList'), // 卡券中心列表数据
            'getCardcentreEnum': A('getCardcentreEnum'), // 枚举
            'getCardcentreListDetail': A('getCardcentreListDetail'), // 明细列表数据
            'getCardcentreListState': A('getCardcentreListState'), // 明细列表-状态

            'getCardcentreDetail': A('getCardcentreDetail'), // 详情数据
            'getCleanDetail': C('getCardcentreDetail'), // 清除详情数据
        },
        sagas: {
            'getCardcentreList': S('getCardcentreList', '/?cmd=com.xqxc.api.pig.mis.biz.user.marketing.CouponMisService.listCoupon', 'POST'),
            'getCardcentreEnum': getCardcentreEnum(T),
            'getCardcentreListDetail': S('getCardcentreListDetail', '/?cmd=com.xqxc.api.pig.mis.biz.user.marketing.CouponMisService.listCouponReceive', 'POST'),
            'getCardcentreListState': S('getCardcentreListState', '/?cmd=com.xqxc.api.pig.mis.biz.user.marketing.CouponMisService.listCouponUsableType', 'POST'),
            'getCardcentreDetail': S('getCardcentreDetail', '/?cmd=com.xqxc.api.pig.mis.biz.user.marketing.CouponMisService.couponDetail', 'POST'),
        },
        reducers: {
            'cardcentreList': R('getCardcentreList', dataList),
            'cardcentreEnum': cardEnum(T),
            'cardcentreListDetail': R('getCardcentreListDetail', dataList),
            'cardcentreListState': R('getCardcentreListState', []),
            'details': R('getCardcentreDetail', {}),
        }
    })
};
export default createModel(model);